import React from "react"
import { isLTPM } from "../../../../components/shared_components_registration"

export const borderStyle = { border: "solid var(--lanzalake-grey) 1px" }

export const registration = {
  url_part: isLTPM ? "runs" : "runreactors",
  close_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.closeButton" }) : "Close"),
  download_table_image: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.download.image.png" }) : "Download Table PNG",
  submit_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.submitButton" }) : "Submit"),
  widget_title: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.download.shift.report" }) : "Generate Shift Report",
  choose_run_details_label: (intl) => (isLTPM ? "Run Header Details" : "Run Header Details"), // TODO - Get Translation
  use_obs_max_label: (intl) =>
    isLTPM ? "Use Observation Max Timestamp(s)" : "Use Observation Max Timestamp(s)", // TODO - Get Translation
  choose_reactors: (intl) => (isLTPM ? intl.formatMessage({ id: "general.reactors" }) : "Choose Reactors"),
  choose_metrics: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.dropdown.choose.metric" }) : "Choose Metrics",
  choose_reference_times: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.choose.reference.times" }) : "Choose Reference Times",
  averaged_over_minutes: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.averaged.over.minutes" }) : "Averaged Over (Minutes)",
  add_new_time: (intl) => (isLTPM ? intl.formatMessage({ id: "general.add" }) : "Add New Time"),
  warn_required_field: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.warning.requiredFormField" }) : "* Required Field",
  err_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.server.error" }) : "Error Occurred!"),
  inoculated_on_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "fermmanagement.inoculated.on" }) : "Inoculated On",
  latest_data_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "fermmanagement.latest.data" }) : "Observation Max",
  run_length_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "fermmanagement.run.length" }) : "Run Length",
  min_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.min" }) : "Min"),
  max_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.max" }) : "Max"),
}

export const Required = ({ intl }) => (
  <div className={"required-message"}>{registration.warn_required_field(intl)}</div>
)
